import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Container } from 'yoso';
import { LoginSecurity } from '~/components/Auth/Login/Security/LoginSecurity';
import { QueryErrorBoundary } from '~/components/Error';
import { EvolvedFriendsErrorFallback } from '~/components/Evolve/Evolved/Error/EvolvedFriendsErrorFallback';
import { EvolvedFriends } from '~/components/Evolve/Evolved/EvolvedFriends';
import { EvolveGuide } from '~/components/Evolve/Guide/EvolveGuide';
import { EvolveHero } from '~/components/Evolve/Hero/EvolveHero';
import { EvolveStatusBar } from '~/components/Evolve/Status/Bar/EvolveStatusBar';
import { EvolutionStatus } from '~/components/Evolve/Status/EvolutionStatus';
import { useFlag } from '~/components/Flag';
import { Page } from '~/components/Page';
import { Section } from '~/components/Page/Section/Section';
import { appliedVersion } from '~/components/Quick/Menu/QuickMenu.hooks';
import { HashScroll } from '~/components/Route/Scroll/HashScroll';
import { StatusBarErrorFallback } from '~/components/Status/Bar/ErrorFallback/StatusBarErrorFallback';
import styles from './EvolvePage.module.scss';

export const EvolvePage = () => {
  const { hide } = useFlag({ name: 'EVOLVE', value: appliedVersion });

  useEffect(() => {
    hide();
  }, [hide]);
  return (
    <Page data-event-page_name="Evolve" className={styles.root}>
      <Container margin="auto">
        <Section className={styles.pageSection}>
          <Section>
            <EvolveHero />
            <ErrorBoundary
              fallbackRender={(props) => (
                <StatusBarErrorFallback {...props} className={styles.statusBar} />
              )}>
              <LoginSecurity>
                <EvolveStatusBar className={styles.statusBar} />
              </LoginSecurity>
            </ErrorBoundary>
          </Section>
          <Section>
            <EvolveGuide />
          </Section>
          <QueryErrorBoundary FallbackComponent={EvolvedFriendsErrorFallback}>
            <Section>
              <EvolvedFriends />
            </Section>
          </QueryErrorBoundary>
          <HashScroll hash="#list" behavior="smooth" position="start">
            <Section>
              <EvolutionStatus />
            </Section>
          </HashScroll>
        </Section>
      </Container>
    </Page>
  );
};
